import { InjectionToken } from '@angular/core';
import {
  CartSimulation,
  DeliveryDateInfo,
  Order,
  OrderProcessStatus,
  PaymentOption,
  PaymentSetup,
  PunchOutPayload,
  SimulatedCart,
  SimulatedOrder,
} from '../../../../core/model';
import { Occ } from '../../../../core/occ/occ-models';
import { Converter } from '../../../../core/util/converter.service';

export const SIMULATED_ORDER_NORMALIZER = new InjectionToken<Converter<Occ.Order, SimulatedOrder | undefined>>(
  'SimulatedOrderNormalizer'
);

export const SIMULATED_CART_NORMALIZER = new InjectionToken<Converter<Occ.Cart, SimulatedCart | undefined>>(
  'SimulatedCartNormalizer'
);

export const ORDER_NORMALIZER = new InjectionToken<Converter<Occ.Order, Order | undefined>>('OrderNormalizer');

export const CART_SIMULATION_NORMALIZER = new InjectionToken<Converter<Occ.CartSimulation, CartSimulation>>(
  'CartSimulationNormalizer'
);

export const PAYMENT_OPTION_NORMALIZER = new InjectionToken<Converter<Occ.PaymentOption, PaymentOption>>(
  'PaymentOptionNormalizer'
);

export const DELIVERY_DATE_INFO_NORMALIZER = new InjectionToken<Converter<Occ.DeliveryDateInfo, DeliveryDateInfo>>(
  'DeliveryDateInfoNormalizer'
);

export const ORDER_PROCESS_STATUS_NORMALIZER = new InjectionToken<Converter<Occ.OrderProcessStatus, OrderProcessStatus>>(
  'OrderProcessStatusNormalizer'
);

export const PAYMENT_SETUP_NORMALIZER = new InjectionToken<Converter<Occ.PaymentRequest, PaymentSetup>>('PaymentSetup');

export const PUNCH_OUT_PAYLOAD_NORMALIZER = new InjectionToken<Converter<Occ.PunchOutPayload, PunchOutPayload>>(
  'PunchOutPayloadNormalizer'
);
